<template>
  <AppDialogContent
    v-model="dialog"
    max-width="1280px"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    hide-default-footer
    hide-actions
    :transition="
      $vuetify.breakpoint.mdAndUp
        ? 'dialog-transition'
        : 'dialog-left-transition'
    "
  >
    <template #header>
      Admin search
    </template>

    <div class="pb-6 px-4">
      <AppTabsCustom v-model="searchType" class="mb-8">
        <v-tab>People</v-tab>
        <v-tab>Horses</v-tab>
        <v-tab>Organisations</v-tab>
        <v-tab>Events</v-tab>
      </AppTabsCustom>

      <v-tabs-items v-model="searchType" touchless>
        <v-tab-item>
          <AdminPeople />
        </v-tab-item>
        <v-tab-item>
          <AdminHorses />
        </v-tab-item>
        <v-tab-item>
          <AdminOrganisations />
        </v-tab-item>
        <v-tab-item>
          <AdminEvents />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </AppDialogContent>
</template>
<script>
import { defineComponent } from "vue";
import AppTabsCustom from "@/components/elements/AppTabsCustom.vue";
import AdminEvents from "./AdminEvents.vue";
import AdminPeople from "./AdminPeople.vue";
import AdminHorses from "./AdminHorses.vue";
import AdminOrganisations from "./AdminOrganisations.vue";

import AppDialogContent from "@elements/AppDialogContent.vue";

export default defineComponent({
  name: "AdminSearch",
  components: {
    AdminEvents,
    AdminPeople,
    AdminHorses,
    AdminOrganisations,
    AppDialogContent,
    AppTabsCustom
  },
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      searchType: 0
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set() {
        this.$emit("input", false);
      }
    }
  },
  watch: {
    $route() {
      this.dialog = false;
    }
  }
});
</script>
